function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMatchStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.325,
    height: 80.629,
    viewBox: "0 0 76.325 80.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.994 37.361a1.566 1.566 0 0 0 1.571-1.435c1.982-11.343 1.913-11.548 13.734-13.8a1.578 1.578 0 0 0 0-3.143c-11.821-2.392-11.547-2.6-13.734-13.734a1.582 1.582 0 0 0-3.143-.068c-2.255 11.274-1.913 11.548-13.8 13.8a1.566 1.566 0 0 0-1.434 1.572 1.516 1.516 0 0 0 1.434 1.572c11.889 2.392 11.685 2.528 13.8 13.8a1.566 1.566 0 0 0 1.572 1.436zm32.8 47.079a2.563 2.563 0 0 0 2.6-2.46c2.182-18.18 3.001-18.654 21.451-21.592 1.64-.205 2.665-1.093 2.665-2.6a2.583 2.583 0 0 0-2.324-2.528c-18.654-3.621-19.61-3.485-21.8-21.592a2.563 2.563 0 0 0-2.6-2.46A2.6 2.6 0 0 0 61.2 33.6c-2.323 18.449-2.938 19-21.729 21.661a2.482 2.482 0 0 0-2.323 2.528 2.59 2.59 0 0 0 2.255 2.6c18.928 3.69 19.406 3.621 21.8 21.729a2.593 2.593 0 0 0 2.589 2.322z",
    transform: "translate(-14.185 -3.811)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMatchStars);
export default __webpack_public_path__ + "static/media/new-match-stars.0cd57b71.svg";
export { ForwardRef as ReactComponent };